import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-play_icon",
  "use": "icon-play_icon-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-play_icon\"><path d=\"M128 138.667c0-47.232 33.323-66.667 74.176-43.563l663.147 374.955c40.96 23.168 40.853 60.8 0 83.882L202.176 928.896c-40.96 23.168-74.176 3.67-74.176-43.563V138.667z\" fill=\"#e6e6e6\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol